/**
 * Storage keys for all atomsWithStorage in the application.
 * Used for reference and to ensure consistency when resetting atoms.
 *
 * @note When adding a new atomWithStorage, add its key here and update
 * the resetAllStorageAtoms function in resetStorage.ts
 */
export const STORAGE_KEYS = {
  PERMISSIONS: 'perms-widget.permissions.v2',
  PERMISSIONS_APPLIED_TO_TOKEN: 'perms-widget.permissions-applied-to-token.v2',
  PERMISSIONS_ON_ACTUAL_TOKEN: 'perms-widget.permissions-on-actual-token.v2',
  PERMISSIONS_WIDGET_INITIALIZED: 'perms-widget.initialized.v2',
  USER_PREFS: 'app.user.prefs',
  TRAIN_TOGETHER_MODE: 'app.trainTogether.mode',
  SEARCH: 'app.search',
  LICENSEE_LOCATION: 'app.licensee.location',
  QUIZ_DRAFT: 'app.quiz.draft',
  PROCEDURE_DRAFT: 'app.procedure.draft',
  EDIT_PLAN_DRAFT: 'app.edit-plan.draft',
  PLAN_BUILD_TIMER: 'app.plan-build.timer',
  SCROLL_POSITIONS: 'app.scroll.positions',
  PLAN_RESOURCE_DEBUG_MOCK: 'dev-menu-plan-resource-debug-mock',
} as const;
